var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video_',{attrs:{"tabList":_vm.tabList,"prodName":_vm.prodName,"linkData":_vm.linkData,"prodCode":_vm.prodCode}})
}
var staticRenderFns = []

export { render, staticRenderFns }